import React, { useState } from "react";
import { Scrollbars } from "react-custom-scrollbars";

export const AppScrollbar = (props: any) => {
  // State
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [top, setTop] = useState({});

  function handleUpdate(values) {
    const { top } = values;

    setTop({ top });
  }

  function renderThumbHorizontal({ style, ...props }) {
    const thumbStyle = {
      visibility: "hidden",
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  }

  function renderThumbVertical({ style, ...props }) {
    const thumbStyle = {
      backgroundColor: "#E4E1E1",
      borderRadius: 0,
      width: "100px",
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  }

  return (
    <Scrollbars
      renderThumbHorizontal={renderThumbHorizontal}
      renderThumbVertical={renderThumbVertical}
      onUpdate={handleUpdate}
      autoHide={true}
      autoHeight
      autoHeightMin={!props.autoHeightMin ? "400" : props.autoHeightMin}
      autoHeightMax={!props.autoHeightMax ? "400" : props.autoHeightMax}
      {...props}
    />
  );
};
